"use client";

import { useCart } from "@/hooks/useCart";
import {
  CheckoutAttemptStage,
  getCheckoutAttemptId,
  getOrCreateCheckoutAttemptId,
  reportCheckoutAttempt,
} from "@/lib/checkout-attempt";
import { useEffect, useRef } from "react";

type CheckoutAttemptTrackerProps = {
  stage: CheckoutAttemptStage;
};

const CheckoutAttemptTracker = ({ stage }: CheckoutAttemptTrackerProps) => {
  const { cart } = useCart();
  const lastReported = useRef<string | null>(null);

  useEffect(() => {
    if (!cart?.id || !cart.items?.length) return;

    const marker = `${cart.id}:${stage}`;
    if (lastReported.current === marker) return;
    lastReported.current = marker;

    const existingAttemptId = getCheckoutAttemptId(cart.id);
    const attemptId = existingAttemptId ?? getOrCreateCheckoutAttemptId(cart.id);

    void reportCheckoutAttempt({
      attempt_id: attemptId,
      cart_id: cart.id,
      event: existingAttemptId ? "progress" : "started",
      stage,
    });
  }, [cart?.id, cart?.items?.length, stage]);

  return null;
};

export default CheckoutAttemptTracker;
